/**
 * Respostas Prontas do Operador — S4 (supervisor): métricas de uso por
 * operador + config do alerta de conduta. Tipos canônicos fonte única FE+Engine
 * (spec 2026-07-16 §6.3/§6.4).
 *
 * REGRA DE OURO (DRIVER §3 / MAC III.9): as métricas são SEMPRE computadas do
 * rastro autoritativo (`Message.metadata` gravado pelo burst na S2) — NUNCA de
 * um contador paralelo (que divergiria). O alerta de conduta é um SINAL para a
 * conversa de gestão; NUNCA bloqueia envio nem pune automaticamente.
 */
export const CONDUCT_ALERT_DEFAULTS = {
    enabled: false,
    pastedWithoutEditThresholdPct: 80,
    windowDays: 7,
    minSampleSize: 5,
};
export const CONDUCT_ALERT_LIMITS = {
    minThresholdPct: 1,
    maxThresholdPct: 100,
    minWindowDays: 1,
    maxWindowDays: 90,
    minMinSampleSize: 1,
    maxMinSampleSize: 10000,
};
/** Percentual `numerador/denominador` arredondado a 1 casa; 0 quando denominador=0. */
export function computePct(numerator, denominator) {
    if (denominator <= 0)
        return 0;
    return Number(((numerator / denominator) * 100).toFixed(1));
}
/**
 * Avalia se um operador deve ser DESTACADO pelo alerta de conduta.
 * SINAL para conversa de gestão — jamais bloqueio/punição.
 * Fonte única FE+Engine (espelha o padrão `evaluateChannelMedia` da S3):
 * config OFF → nunca destaca; amostra abaixo do mínimo → nunca destaca;
 * senão destaca quando o % de coladas-sem-edição atinge o limiar.
 */
export function evaluateConductAlert(metric, config) {
    if (!config.enabled)
        return false;
    if (metric.cannedCount < config.minSampleSize)
        return false;
    return metric.pastedWithoutEditPct >= config.pastedWithoutEditThresholdPct;
}
/** Normaliza/valida um patch de config contra os limites; lança string de erro se inválido. */
export function clampConductAlertPatch(patch) {
    const out = {};
    if (patch.enabled !== undefined) {
        if (typeof patch.enabled !== 'boolean')
            return { ok: false, error: 'enabled deve ser boolean' };
        out.enabled = patch.enabled;
    }
    if (patch.pastedWithoutEditThresholdPct !== undefined) {
        const v = patch.pastedWithoutEditThresholdPct;
        if (!Number.isInteger(v) ||
            v < CONDUCT_ALERT_LIMITS.minThresholdPct ||
            v > CONDUCT_ALERT_LIMITS.maxThresholdPct) {
            return {
                ok: false,
                error: `pastedWithoutEditThresholdPct deve ser inteiro entre ${CONDUCT_ALERT_LIMITS.minThresholdPct} e ${CONDUCT_ALERT_LIMITS.maxThresholdPct}`,
            };
        }
        out.pastedWithoutEditThresholdPct = v;
    }
    if (patch.windowDays !== undefined) {
        const v = patch.windowDays;
        if (!Number.isInteger(v) ||
            v < CONDUCT_ALERT_LIMITS.minWindowDays ||
            v > CONDUCT_ALERT_LIMITS.maxWindowDays) {
            return {
                ok: false,
                error: `windowDays deve ser inteiro entre ${CONDUCT_ALERT_LIMITS.minWindowDays} e ${CONDUCT_ALERT_LIMITS.maxWindowDays}`,
            };
        }
        out.windowDays = v;
    }
    if (patch.minSampleSize !== undefined) {
        const v = patch.minSampleSize;
        if (!Number.isInteger(v) ||
            v < CONDUCT_ALERT_LIMITS.minMinSampleSize ||
            v > CONDUCT_ALERT_LIMITS.maxMinSampleSize) {
            return {
                ok: false,
                error: `minSampleSize deve ser inteiro entre ${CONDUCT_ALERT_LIMITS.minMinSampleSize} e ${CONDUCT_ALERT_LIMITS.maxMinSampleSize}`,
            };
        }
        out.minSampleSize = v;
    }
    return { ok: true, patch: out };
}
//# sourceMappingURL=metrics.js.map